import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

import { lazy } from 'react';

const DashboardPage = lazy(() =>
  import('./routes/DashboardPage').then((m) => ({ default: m.DashboardPage })),
);

export const dashboardRoutes: RouteObject[] = [
  { path: ROUTES.dashboard, element: <DashboardPage /> },
];
